import SvgIcon from "./SvgIcon";
import CrossFadeIcon from "./CrossFadeIcon";

export {
    SvgIcon,
    CrossFadeIcon,
};
